import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { TarifaList } from "./list/list";
import { TarifaEdit } from "./edit/edit";

export class TarifaCatalogo extends React.Component {
    render() {
        return (
            <div>
                <Route exact path="/catalogos/Tarifa"  component={TarifaList} />
                <Route path="/catalogos/Tarifa/:id"  component={TarifaEdit} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifas/index.tsx